import type { Plan } from "../types/landing";
export const plans: Plan[] = [
  {
    id: "base",
    name: "Base",
    fullName: "Megapack Japonés Base",
    tagline: "Tu recorrido principal de aprendizaje.",
    summary: "7 tomos principales, de cero a N4",
    ebooks: 7,
    includes: ["7 tomos principales, desde cero hasta el N4"],
    cta: "Elegir Base",
  },
  {
    id: "pro",
    name: "Pro",
    fullName: "Megapack Japonés Pro",
    tagline: "Aprendizaje + práctica adicional de kanji.",
    summary: "7 tomos + 5 bonos de kanji",
    ebooks: 12,
    includes: ["7 tomos principales", "5 bonos de kanji"],
    cta: "Elegir Pro",
  },
  {
    id: "completo",
    name: "Completo",
    fullName: "Megapack Japonés Completo",
    tagline: "Aprendé, reforzá y llevá tu japonés a situaciones reales.",
    summary: "7 tomos + 5 bonos de kanji + japonés para viajes + diccionario de 5.000 palabras",
    ebooks: 14,
    includes: [
      "7 tomos principales",
      "5 bonos de kanji",
      "Japonés práctico para viajes",
      "Diccionario japonés–español de 5.000 palabras",
    ],
    cta: "Quiero el Completo",
  },
];
export const completoHighlights = [
  "Estudiás con la secuencia de 7 tomos",
  "Reforzás kanji con 5 bonos",
  "Consultás expresiones según la situación de viaje",
  "Buscás vocabulario en un solo diccionario",
];
export const planTableRows = [
  { label: "Tomos 1 al 7", base: true, pro: true, completo: true },
  { label: "Cinco bonos de kanji", base: false, pro: true, completo: true },
  { label: "Japonés práctico para viajes", base: false, pro: false, completo: true },
  { label: "Diccionario de 5.000 palabras", base: false, pro: false, completo: true },
];
